import React from "react";

const InTransit = () => {
  return (
    <>
      <svg
        width={40}
        height={40}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M25 15H30.625V14.375L28.357 10.9729C28.2856 10.8659 28.1889 10.7781 28.0755 10.7174C27.9621 10.6567 27.8355 10.625 27.7069 10.625H25V15Z"
          fill="#EB423F"
        />
        <path
          d="M25 25V21.25H36.5625C36.9769 21.25 37.3743 21.4146 37.6674 21.7076C37.9604 22.0007 38.125 22.3981 38.125 22.8125V30.4688C38.125 30.676 38.0427 30.8747 37.8962 31.0212C37.7497 31.1677 37.551 31.25 37.3438 31.25H2.65625C2.44905 31.25 2.25034 31.1677 2.10382 31.0212C1.95731 30.8747 1.875 30.676 1.875 30.4688V25H25Z"
          fill="#EB423F"
        />
        <path
          d="M25 21.875H36.875V21.25L32.577 15.3402C32.3595 15.0413 32.0744 14.798 31.745 14.6302C31.4156 14.4625 31.0512 14.375 30.6815 14.375H25V21.875Z"
          fill="#FEECE8"
        />
        <path
          d="M24.8438 8.125H2.65625C2.44905 8.125 2.25034 8.20731 2.10382 8.35382C1.95731 8.50034 1.875 8.69905 1.875 8.90625V25.625H25.625V8.90625C25.625 8.69905 25.5427 8.50034 25.3962 8.35382C25.2497 8.20731 25.051 8.125 24.8438 8.125Z"
          fill="#FAC850"
        />
        <path
          d="M31.875 36.25C29.8039 36.25 28.125 34.5711 28.125 32.5C28.125 30.4289 29.8039 28.75 31.875 28.75C33.9461 28.75 35.625 30.4289 35.625 32.5C35.625 34.5711 33.9461 36.25 31.875 36.25Z"
          fill="#4D4D4D"
        />
        <path
          d="M8.125 36.25C6.05393 36.25 4.375 34.5711 4.375 32.5C4.375 30.4289 6.05393 28.75 8.125 28.75C10.1961 28.75 11.875 30.4289 11.875 32.5C11.875 34.5711 10.1961 36.25 8.125 36.25Z"
          fill="#4D4D4D"
        />
        <path d="M30 23.125H27.5V24.375H30V23.125Z" fill="#FFFEFD" />
        <path
          d="M36.5625 26.25H38.125V22.8125C38.125 22.3981 37.9604 22.0007 37.6674 21.7076C37.3743 21.4146 36.9769 21.25 36.5625 21.25H35V24.6875C35 25.1019 35.1646 25.4993 35.4576 25.7924C35.7507 26.0854 36.1481 26.25 36.5625 26.25Z"
          fill="#FAC850"
        />
        <path d="M23.75 10H22.5V11.25H23.75V10Z" fill="#FFFAF6" />
        <path d="M23.75 22.5H22.5V23.75H23.75V22.5Z" fill="#FFFAF6" />
        <path d="M5 10H3.75V11.25H5V10Z" fill="#FFFAF6" />
        <path d="M5 22.5H3.75V23.75H5V22.5Z" fill="#FFFAF6" />
        <path
          d="M31.875 33.75C31.1846 33.75 30.625 33.1904 30.625 32.5C30.625 31.8096 31.1846 31.25 31.875 31.25C32.5654 31.25 33.125 31.8096 33.125 32.5C33.125 33.1904 32.5654 33.75 31.875 33.75Z"
          fill="#FEFEFE"
        />
        <path
          d="M8.125 33.75C7.43464 33.75 6.875 33.1904 6.875 32.5C6.875 31.8096 7.43464 31.25 8.125 31.25C8.81536 31.25 9.375 31.8096 9.375 32.5C9.375 33.1904 8.81536 33.75 8.125 33.75Z"
          fill="#FEFEFE"
        />
        <path d="M38.75 10H33.75V11.25H38.75V10Z" fill="#B8B8B8" />
        <path d="M32.5 10H31.25V11.25H32.5V10Z" fill="#B8B8B8" />
        <path d="M33.125 3.75H23.125V5H33.125V3.75Z" fill="#B8B8B8" />
        <path d="M21.875 3.75H20.625V5H21.875V3.75Z" fill="#B8B8B8" />
        <path d="M16.25 5H6.25V6.25H16.25V5Z" fill="#B8B8B8" />
        <path d="M5 5H3.75V6.25H5V5Z" fill="#B8B8B8" />
        <path d="M26.875 34.375H15.625V35.625H26.875V34.375Z" fill="#B8B8B8" />
        <path d="M14.375 34.375H13.125V35.625H14.375V34.375Z" fill="#B8B8B8" />
      </svg>
    </>
  );
};

export default InTransit;
